export const decimalPlacesDataSource = [
    { text: "0", value: 0 },
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },
  ];
  export const digitGroupingDataSource = [
    { text: "Indian Format", value: "Indian", example: "12,34,567" },
    { text: "International Format", value: "International", example: "1,234,567" },
    { text: "No grouping", value: "none", example: "1234567" },
  ];
  export const largeNumberAbbreviationDataSource = [
    { text: "Thousands, Millions, Billions ", value: "KMB", symbol: "K,M,B" },
    { text: "Lakhs, Crores ", value: "LCr", symbol: "L,Cr" },
    { text: "None", value: "none" },
  ];